import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';
import {useKeycloak} from '@react-keycloak/web';
import { map } from './RouteMap';

const PrivateRoute = ({ component: Component, path, ...rest }) => {
  const { keycloak } = useKeycloak();
  const isLoggedIn = keycloak.authenticated;

  return (
    <Route
      {...rest}
      path={path}
      render={(props) => (
        (isLoggedIn || [map.routes.map].includes(path)) ?
          <Component {...props} />
            : null
          // <Redirect to={map.routes.login} />
      )}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.shape({}).isRequired,
  path: PropTypes.string.isRequired,
};

export default PrivateRoute;
